import { Navigate, Outlet } from "react-router";

import { useIsAuthenticated } from "@/features/auth/lib/use-auth";

export function ProtectedRoute() {
	const isAuthenticated = useIsAuthenticated();

	if (!isAuthenticated) {
		return <Navigate to="/login" replace />;
	}

	return <Outlet />;
}
